webpackJsonp([35783957827783],{

/***/ 298:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 299:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 25:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/helloworld.cbde7c81.jpg";

/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(13);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _helloworld = __webpack_require__(25);
	
	var _helloworld2 = _interopRequireDefault(_helloworld);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(298);
	__webpack_require__(299);
	
	var containerStyle = {
	  margin: '0%',
	  marginTop: '16px'
	};
	
	var centerImgStyle = {
	  borderRadius: '50%',
	  position: 'inline',
	  width: '298px',
	  marginTop: '11px'
	};
	
	var circleStyle = {
	  position: 'relative',
	  width: '100%',
	  margin: '0 auto'
	};
	
	var circleTextStyle = {
	  fontFamily: 'Courier, monospaced',
	  fontSize: '16px',
	  fill: '#605980'
	};
	
	var circleSvgStyle = {
	  position: 'absolute',
	  left: '0',
	  top: '0',
	  width: '100%',
	  overflow: 'visible'
	};
	
	exports.default = function () {
	  return _react2.default.createElement(
	    "div",
	    { className: "content" },
	    _react2.default.createElement(
	      "h1",
	      { className: "title-area" },
	      _react2.default.createElement(
	        "div",
	        { className: "upper-title" },
	        "Shane"
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "lower-title" },
	        "Cummerford"
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { id: "container", style: containerStyle },
	      _react2.default.createElement(
	        "div",
	        { id: "circle", style: circleStyle },
	        _react2.default.createElement(
	          "svg",
	          { style: circleSvgStyle,
	            className: "lead-circle-svg",
	            version: "1.1",
	            xmlns: "http://www.w3.org/2000/svg",
	            xmlnsXlink: "http://www.w3.org/1999/xlink",
	            x: "0px", y: "0px", width: "320px", height: "320px", viewBox: "0 0 320 320", "enable-background": "new 0 0 300 300", xmlSpace: "preserve" },
	          _react2.default.createElement(
	            "defs",
	            null,
	            _react2.default.createElement("path", { id: "circlePath", d: " M 160, 160 m -160, 0 a 160,160 0 0,1 320,0 a 160,160 0 0,1 -320,0 " })
	          ),
	          _react2.default.createElement(
	            "g",
	            null,
	            _react2.default.createElement("use", { xlinkHref: "#circlePath", fill: "rgba(50, 50, 50, 0.0)" }),
	            _react2.default.createElement(
	              "text",
	              { style: circleTextStyle },
	              _react2.default.createElement(
	                "textPath",
	                { xlinkHref: "#circlePath" },
	                "\"Your friend online\""
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: "/about" },
	          _react2.default.createElement("img", { id: "center-img",
	            className: "lead-circle-img",
	            src: _helloworld2.default,
	            style: centerImgStyle,
	            alt: "Shane Cummerford"
	          })
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-68c393d2b1a98df85548.js